/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import { useTranslation } from "react-i18next";
import CreateRecordButton from "../input/CreateRecordButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteSingleRecordButton from "../input/DeleteSingleRecordButton";import { Tooltip, toggleClass, } from '@grapecity/wijmo';
import "./gridEvent.css"

function TkPartnerProcessCost(props) {
    const table = "TkPartnerProcessCost";
    const view = "TkVwPartnerProcessCost";
    const id = "TkPartnerProcessCost";

    const { t } = useTranslation();

    const [tkPartnerProcessCostSchema, setTkPartnerProcessCostSchema] = useState();
    const [tkPartnerProcessCostGrid, setTkPartnerProcessCostGrid] = useState();
    const [tkPartnerProcessCostApi, setTkPartnerProcessCostApi] = useState();
    const [tkPartnerProcessCostDataIsEmpty, setTkPartnerProcessCostDataIsEmpty] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    useEffect(() => {
        let mounted = true;

        (async () => {
            let schema = await getSchema(table);

            if (mounted) {
                setTkPartnerProcessCostSchema(schema);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        let tooltip = new Tooltip();
        (async () => {
            if (tkPartnerProcessCostGrid) {
                tkPartnerProcessCostGrid.formatItem.addHandler((flex, element) => {
                    if (element.panel === flex.cells) {
                        let item = flex.rows[element.row].dataItem
                        let binding = flex.columns[element.col].binding
                        let data = item.description ? item.description : null;
                        toggleClass(element.cell, 'wj-has-notes', binding === "description" && data !== null );
                        if(binding === "description" && data !== null) {
                            tooltip.setTooltip(element.cell, `<h1>${data}<h1>`);
                        }
                    }
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tkPartnerProcessCostGrid]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    return (
        <BasicCrudScreenType
            id={id}
            headerTitle={t("term.tkPartnerProcessCost")}
            table={table}
            view={view}
            onInitialized={(grid) => {
                grid.selectionMode = "Row";
                setTkPartnerProcessCostGrid(grid);
            }}
            onApiInitialized={(api) => {
                setTkPartnerProcessCostApi(api);
            }}
            onLoadData={(data) => {
                const isEmpty = data.length < 1 ? true : false;
                setTkPartnerProcessCostDataIsEmpty(isEmpty);
            }}
            onAppendButtonInFrontOfSearch={() => (
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={tkPartnerProcessCostSchema && tkPartnerProcessCostSchema.name}
                        accessMethod="POST"
                    >
                        <CreateRecordButton
                            id={id}
                            schema={tkPartnerProcessCostSchema}
                            refresh={tkPartnerProcessCostApi}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkPartnerProcessCostSchema && tkPartnerProcessCostSchema.name}
                        accessMethod={
                            tkPartnerProcessCostSchema && (tkPartnerProcessCostSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <UpdateRecordButton
                            id={id}
                            schema={tkPartnerProcessCostSchema}
                            grid={tkPartnerProcessCostGrid}
                            refresh={tkPartnerProcessCostApi}
                            disabled={tkPartnerProcessCostDataIsEmpty}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkPartnerProcessCostSchema && tkPartnerProcessCostSchema.name}
                        accessMethod="DELETE"
                    >
                        <DeleteSingleRecordButton
                            id={id}
                            schema={tkPartnerProcessCostSchema}
                            grid={tkPartnerProcessCostGrid}
                            refresh={tkPartnerProcessCostApi}
                            makeItemName={(row) => {
                                return `{
                                ${t("columnName.companyName")}: ${row.companyName}, 
                                ${t("columnName.processName")}: ${row.processName}
                            }`;
                            }}
                            color="secondary"
                            disabled={tkPartnerProcessCostDataIsEmpty}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            )}
            noCreate
            noEdit
            noDelete
            noExcel
        />
    );
}

export default TkPartnerProcessCost;
